import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from 'src/app/_service/message-service';
import { AuthenticationService, UserService } from 'src/app/_services';
import { VendorService } from 'src/app/_services/vendor.services';
import { Subscription, interval } from 'rxjs';
import { TariffManagementService } from '../services/tariff-management-service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { countries } from 'src/app/util/enums/countries.enum';
import { debounce } from 'rxjs/operators';

export interface tariffdata {
  id: number;
  country_code: string;
  vendor_id: string;
  currency: string;
  type: string;
  name: string;
  tariff_detail: {
    start_time: string;
    end_time: string;
    type: string;
    tax: string;
    price: number;
    step_size: number;
    day_of_week: string[];
  }[];
}
declare var $: any;
@Component({
  selector: 'telio-create-tariff',
  templateUrl: './create-tariff.component.html',
  styleUrls: ['./create-tariff.component.scss']
})
export class CreateTariffComponent implements OnInit {
  userSubscription = new Subscription()
  tariffForm: UntypedFormGroup;
  isDataAvailable: Promise<boolean>;
  priceTypeOptions = ['FIXED', 'VARIABLE'];
  listClone: any = [];
  type = [{ id: 1, value: 'TIME' }, { id: 2, value: 'ENERGY' }];
  maxRows = 35;
  list: any = [];
  vendorType;
  vendorlist: any = [];
  slotCounts: number[] = [1];
  countryList = [];
  daysMap: Map<number, string[]> = new Map<number, string[]>();
  subscription: Subscription = new Subscription;
  countries = ['us', 'in', 'np'];
  numRegex = /^\d*[.,]?\d{0,2}$/
  specialRegex = new RegExp('^[a-zA-Z0-9_\\-#@ ]+$');
  timezone;
  slotData;
  sequenceNumber = [];
  daysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
  selectedDays: string[][] = [];
  isEdit = false;
  tariffdata: tariffdata[]
  tariffDetails: any;
  id: string;
  tax = [];
  subid = [];
  detailCount: number = 1;
  vendormailId = '';
  editlength;
  rs;
  operator = null;
  country = null;

  constructor(readonly userInfoService: UserInfoService,
    readonly translate: TranslateService,
    private toastr: SnackbarService,
    public dialog: MatDialog,
    private router: Router,
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private vendorservice: VendorService,
    private route: ActivatedRoute,
    private tariffService: TariffManagementService,
    private authService: AuthenticationService) {
    this.getvendorlist();
    this.countryList = this.userInfoService.countryList;
    this.vendormailId = this.userInfoService.userDetails.email;
  }

  ngOnInit(): void {
    this.subscription.add(this.route.queryParams.subscribe(params => {
      if (params['tariffData']) {
        this.tariffDetails = JSON.parse(params['tariffData']);
        this.isEdit = params['isEdit'];
        this.id = this.tariffDetails.id;
        if (this.isEdit) {
          this.slotData = this.groupSlotsByDayCombination(this.tariffDetails.tariff_detail);
        }
      }
    }));
    this.initForm();
    this.isEdit && this.addCurrentValue();
    this.tariffForm.valueChanges
      .pipe(debounce(() => interval(500)))
      .subscribe(data => {
        this.onTypeChangeUpdate();
      });
    if (!this.userInfoService.isAdminGroup()) {
      this.operator = this.tariffDetails ? this.tariffDetails.vendorId : this.vendormailId
    }
    if (this.authService.getTariffDialog()) {
      this.operator = this.authService.getOperatorForTariff()
    }
  }

  private initForm(): void {
    this.tariffForm = this.fb.group({
      name: [this.tariffDetails ? { value: this.tariffDetails.name, disabled: true } : '', [Validators.required, Validators.pattern(this.specialRegex)]],
      mailID: [this.userInfoService.isAdminGroup() ? (this.authService.getTariffDialog() ? { value: this.authService.getOperatorForTariff(), disabled: true } : (this.tariffDetails ? { value: this.tariffDetails.vendor_id, disabled: true } : '')) : { value: this.vendormailId, disabled: true }, Validators.required],
      currency: [this.tariffDetails ? { value: this.tariffDetails.currency, disabled: true } : { value: '', disabled: true }],
      countryCode: [this.tariffDetails ? { value: this.tariffDetails.country_code, disabled: true } : '', Validators.required],
      priceType: [{ value: this.tariffDetails ? this.tariffDetails.type : this.priceTypeOptions[0], disabled: this.isEdit ? true : false }],
      fixedDetails: this.fb.group({
        price: [this.tariffDetails ? this.tariffDetails.tariff_detail[0].price : '', [Validators.required, Validators.pattern(this.numRegex)]],
        stepSize: [this.tariffDetails ? this.tariffDetails.tariff_detail[0].step_size : ''],
        parameterType: [this.tariffDetails ? this.tariffDetails.tariff_detail[0].type : this.type[0].value, Validators.required]
      }),
      variableDetails: this.fb.array([])
    });

    if (!this.isEdit) { this.addTariffsDetail(true); }
    this.tariffForm.get('fixedDetails.parameterType').valueChanges.subscribe((selectedType) => {
      if (selectedType == 'TIME') {
        this.tariffForm.get('fixedDetails.stepSize').setValidators(Validators.required);
        this.tariffForm.get('fixedDetails.stepSize').updateValueAndValidity()
      }
      else {
        this.tariffForm.get('fixedDetails.stepSize').setValidators(null);
        this.tariffForm.get('fixedDetails.stepSize').updateValueAndValidity()
      }

    })
    this.tariffForm.get('countryCode').valueChanges.subscribe(selectedCountryCode => {
      this.userService.getLanguagesbycountry().subscribe((res: any) => {
        const countryData = res.find(country => country.country === selectedCountryCode);
        if (countryData) {
          const currency = countryData.currency;
          const currencySymbol = countryData.currencySymbol;
          this.tariffForm.get('currency').setValue(currency);
          this.rs = currencySymbol;
        } else {
          this.rs = ''
        }
      });
    });
    this.formatNumber(this.tariffForm.get('fixedDetails.price'));
    this.tariffForm.get('mailID').valueChanges
      .subscribe(typedvalue => {
        this.list = typedvalue ? this.filter(typedvalue) : this.listClone;
      })
    if (!this.isEdit) { this.selectUnselectedDays(0); }
  }

  get variableDetailsArray(): UntypedFormArray {
    return this.tariffForm.get('variableDetails') as UntypedFormArray;
  }

  private filter(name: string) {
    const filterValue = name.toLowerCase();

    return this.listClone.filter(
      (option: any) => option.name.toLowerCase().includes(filterValue)
    );
  }

  addTariffsDetail(isInitial: boolean = false) {
    const variableDetails = this.tariffForm.get('variableDetails') as UntypedFormArray;
    const tariffDetail = this.createVariableDetailRow();
    if (isInitial) {
      const slot = tariffDetail.get('slots') as UntypedFormArray;
      slot.at(0).patchValue({ from: '12:00 AM', to: '11:59 PM' });
    }
    variableDetails.push(tariffDetail);
  }

  createVariableDetailRow(): UntypedFormGroup {
    const detail = this.fb.group({
      slots: this.fb.array([this.createSlot()]),
    },);
    this.selectedDays.push([]);
    return detail;
  }

  createSlot(val?: string): UntypedFormGroup {
    let Value = 'TIME';
    return this.fb.group({
      type: [{ value: val ? val : Value, disabled: val ? true : false }, Validators.required],
      from: [{ value: '', disabled: true }, Validators.required],
      to: ['', Validators.required],
      price: ['', [Validators.required, Validators.pattern(this.numRegex)]],
    });
  }

  groupSlotsByDayCombination(slots: any[]): any[] {
    const groupedSlots = [];
    slots.forEach(slot => {
      const combinationKey = JSON.stringify(slot.day_of_week.sort());
      const existingGroup = groupedSlots.find(group => JSON.stringify(group.dayOfWeek.sort()) === combinationKey);
      if (existingGroup) {
        existingGroup.slots.push(slot);
      } else {
        groupedSlots.push({ dayOfWeek: slot.day_of_week, slots: [slot] });
      }
    });
    return groupedSlots;
  }

  addCurrentValue() {
    this.slotData.map((detail, i) => {
      detail.dayOfWeek.map(day => {
        this.addDayToMap(i, day);
      })

      let detailSlots = this.fb.array([]);
      let taxRow = [];
      let subIdRow = [];
      detail.slots.map((slot, j) => {
        taxRow.push(slot.tax);
        subIdRow.push(slot.id);
        const jTrue = j == 0;
        const newRow = this.fb.group({
          type: [{ value: slot.type, disabled: jTrue ? false : true }, Validators.required],
          from: [{ value: slot.start_time, disabled: true }, Validators.required],
          to: [slot.end_time, Validators.required],
          price: [slot.price, [Validators.required, Validators.pattern(this.numRegex)]],
        })
        detailSlots.push(newRow)
        this.tax.push(taxRow);
        this.subid.push(subIdRow);
      })
      const newDetail = this.fb.group({ slots: detailSlots })
      this.variableDetailsArray.push(newDetail)
    })
    this.editlength = this.variableDetailsArray.length
  }

  onSubmit(): void {
    for (let i = 0; i < this.variableDetailsArray.length; i++)
      if (!this.checkCoverage(i))
        return;
    this.getTimezone(this.tariffForm.get('countryCode').value);
    const formData = this.tariffForm.value;
    const maininput = {
      'country_code': formData.countryCode = this.tariffForm.get('countryCode').value,
      'currency': formData.currency = this.tariffForm.get('currency').value,
      'vendor_id': formData.mailID = this.tariffForm.get('mailID').value,
      'type': formData.priceType = this.tariffForm.get('priceType').value,
      'name': formData.name = this.tariffForm.get('name').value,
      'tenant_id': this.userInfoService.userDetails.tenantID,
      'tariff_detail': []
    };
    let input = this.isEdit ? { ...maininput, 'id': this.id } : maininput

    const fixedtaxinput = {
      'start_time': '00:00',
      'end_time': '23:59',
      'type': formData.fixedDetails.parameterType,
      'price': formData.fixedDetails.price,
      'day_of_week': ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
    }
    if (formData.priceType === this.priceTypeOptions[0]) {
      if (formData.fixedDetails.parameterType === this.type[0].value) {
        input.tariff_detail.push(this.isEdit ? { ...fixedtaxinput, 'tax': this.formatTax(this.tax[0]), 'id': this.subid[0][0], 'step_size': formData.fixedDetails.stepSize } : { ...fixedtaxinput, 'step_size': formData.fixedDetails.stepSize });
      } else {
        input.tariff_detail.push(this.isEdit ? { ...fixedtaxinput, 'tax': this.formatTax(this.tax[0]), 'id': this.subid[0][0] } : { ...fixedtaxinput });
      }

    } else {
      const detailArr = formData.variableDetails.map((detail, i) => {
        const startTimeArray = this.variableDetailsArray.at(i).get('slots') as UntypedFormArray
        const slot_detail = detail.slots.map((slot, j) => {
          const variabletaxdata = {
            'start_time': this.convert12HrTo24Hr(slot.from = startTimeArray.at(j).get('from').value),
            'end_time': this.convert12HrTo24Hr(slot.to),
            'type': slot.type = startTimeArray.at(j).get('type').value,
            'price': slot.price,
            'day_of_week': this.daysMap.get(i),
            'sequence': j + 1,
          }
          return this.isEdit ? { ...variabletaxdata, 'tax': this.assignTax(i, j), 'id': this.assignid(i, j) } : variabletaxdata;
        })
        return slot_detail;
      });
      detailArr.map((arr) => {
        arr.map(slot => {
          input.tariff_detail = [...input.tariff_detail, slot]
        })
      })
    }
    if (!this.isEdit) {
      this.subscription.add(this.tariffService.createTariff(input, this.timezone).subscribe(r => {
        if (r) {
          this.toastr.success(this.translate.instant('tarrif.create.addSuccess'));
          this.authService.setAddStationTariff(input.name);
          this.navigateTo();
        } else {
          this.toastr.error(r);
          this.navigateTo();
        }
      },
        err => {
          this.toastr.error(err.message);
        }
      ));
    } else {
      this.subscription.add(this.tariffService.editTariff(input, this.id).subscribe(r => {
        if (r) {
          this.toastr.success(this.translate.instant('schedulereport.editSuccess'));
          this.navigateTo();
        } else {
          this.toastr.error(r);
          this.navigateTo();
        }
      },
        err => {
          this.toastr.error(err.message);
        }));
    }
  }

  back() {
    this.confirmCancel()
  }

  assignTax(i: number, j: number) {
    if (i >= this.editlength)
      return '';
    if (this.tax[i][j])
      return this.formatTax(this.tax[i][j]);
    return '';

  }

  assignid(i: number, j: number) {
    if (i >= this.editlength)
      return '';
    if (this.subid[i][j])
      return this.subid[i][j]
    return '';

  }

  getvendorlist() {
    this.vendorservice.getAllVendors(1,1000,'','asc','').subscribe(
      ((resp: any) => {
        this.vendorlist = resp.content;
        !!this.vendorlist && this.vendorlist.forEach((ele: any, i: number) => {
          this.list.push({
            'name': this.vendorlist[i].name,
            'id': this.vendorlist[i].vendor_id,
          });
          this.listClone.push({
            'name': this.vendorlist[i].name,
            'id': this.vendorlist[i].vendor_id,
          });
        });
        this.list.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
      })
    );
  }


  formatNumber(control: AbstractControl): void {
    const value = control.value;
    if (!!value && value !== '') {
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue)) {
        control.setValue(numericValue.toFixed(2), { emitEvent: false });
      }
    }
  }

  formatTax(tax: number) {
    const value = tax.toString()
    if (!!value && value !== '') {
      const numericValue = parseFloat(value);
      if (!isNaN(numericValue)) {
        return numericValue.toFixed(2);
      }
    }
  }

  setBelowSlotTime(i: number, j: number) {
    const slotsArray = this.variableDetailsArray.at(i).get('slots') as UntypedFormArray;
    if (slotsArray.length !== j + 1) {
      slotsArray.at(j + 1).get('from').setValue(slotsArray.at(j).get('to').value);
    }
  }

  toTimeChange(i: number, j: number) {
    this.checkSlotOverlap(i, j);
    this.setBelowSlotTime(i, j);
    this.ifTwelveSetElevenFiftyNine(i, j);
    this.fromTimeGreaterThanToTime(i, j);
  }

  getCurrencyForCountry(countryCode: string) {
    this.userService.getLanguagesbycountry().subscribe((res: any) => {
      const countryData = res.find(country => country.country === countryCode);
      if (countryData) {
        return countryData.currency;
      } else {
        return '';
      }
    })
  }

  navigateTo() {
    if (this.authService.getTariffDialog()) {
      this.dialog.closeAll()
    } else {
      this.router.navigate(['/dashboard/tariff-management', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    }
  }

  getCountryName(country) {
    let countryObj = this.countryList.find(res => res.country === country)
    return !!countryObj ? countryObj.country_description : ''
  }

  parseTime(timeString: string): number {
    const parts = timeString.split(':');
    const hour = parseInt(parts[0], 10);
    const minute = parseInt(parts[1].split(' ')[0], 10);
    if (parts[1].split(' ')[1] === 'PM' && hour !== 12) {
      return (hour + 12) * 60 + minute;
    } else if (parts[1].split(' ')[1] === 'AM' && hour === 12) {
      return minute;
    } else {
      return hour * 60 + minute;
    }
  }

  checkFormValid(): boolean {
    if (!this.isEdit) {
      switch (true) {
        case (this.tariffForm.value.priceType === this.priceTypeOptions[0] && !this.isEdit):
          return this.detailsFormCheck() && this.tariffForm.controls['fixedDetails'].valid;
        case (this.tariffForm.value.priceType === this.priceTypeOptions[1] && !this.isEdit):
          return this.detailsFormCheck() && this.tariffForm.controls['variableDetails'].valid && this.areAllDaysSelected() && !this.isAnyDetailWithoutRow();
        default:
          return false;
      }
    } else {
      switch (true) {
        case (this.tariffForm.get('priceType').value === this.priceTypeOptions[0]):
          return this.tariffForm.controls['fixedDetails'].valid;
        case (this.tariffForm.get('priceType').value === this.priceTypeOptions[1]):
          return this.tariffForm.controls['variableDetails'].valid && this.areAllDaysSelected() && !this.isAnyDetailWithoutRow();
      }

    }
  }

  detailsFormCheck(): boolean {
    return ((this.tariffForm.controls['countryCode'].valid || this.tariffForm.controls['countryCode'].status == 'DISABLED') &&
      (this.tariffForm.controls['currency'].valid || this.tariffForm.controls['currency'].status == 'DISABLED') &&
      (this.tariffForm.controls['mailID'].valid || this.tariffForm.controls['mailID'].status == 'DISABLED') &&
      (this.tariffForm.controls['name'].valid || this.tariffForm.controls['name'].status == 'DISABLED'));
  }


  confirmCancel(): void {
    if (this.tariffForm.dirty || this.tariffForm.touched) {
      let dialogRef = this.dialog.open(GeneralDialogComponent, {
        width: '50vw',
        height: '200px',
        data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('createStation.cancelmessage') }
      }).afterClosed().subscribe(res => {
        if (res && res === 'Yes') {
          if (this.id) {
            this.router.navigate(['/dashboard/tariff-management', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
          } else {
            this.navigateTo();
          }
        }
      });
    } else {
      if (this.id) {
        this.router.navigate(['/dashboard/tariff-management', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
      } else {
        this.navigateTo();
      }
    }
  }

  toggleDay(detailIndex: number, day: string): void {
    if (this.isDayUsed(day)) {
      this.removeDayFromMap(detailIndex, day)
      return;
    }
    this.addDayToMap(detailIndex, day);
  }

  isDaySelected(detailIndex: number, day: string): boolean {
    if (this.daysMap.size == 0)
      return false;
    return this.daysMap.get(detailIndex).includes(day);
  }

  addTariffDetail(): void {
    if (this.detailCount < 7) {
      const newRow = this.createVariableDetailRow();
      const slotsArray = newRow.get('slots') as UntypedFormArray;
      const firstSlot = slotsArray.at(0);
      if (firstSlot) {
        firstSlot.get('from').setValue('12:00 AM');
        firstSlot.get('to').setValue('11:59 PM');
      }
      this.variableDetailsArray.push(newRow);
      this.detailCount++;
      this.selectUnselectedDays(this.variableDetailsArray.length - 1);
    }
  }

  removeTariffDetail(index: number): void {
    if (index > 0) {
      this.variableDetailsArray.removeAt(index);
      this.detailCount--;
      this.removeDaysForDeletedTariff(index);
    }
  }

  addSlot(detailIndex: number): void {
    const slots = this.variableDetailsArray.at(detailIndex).get('slots') as UntypedFormArray;
    if (slots.length < 5) {
      const slotZeroType = slots.at(0).get('type').value;
      const newSlot = !!slotZeroType ? this.createSlot(slotZeroType) : this.createSlot();
      if (slots.length > 0) {
        const previousSlot = slots.at(slots.length - 1) as UntypedFormGroup;
        newSlot.get('from').setValue(previousSlot.get('to').value);
      }
      slots.push(newSlot);
      this.slotCounts[detailIndex]++;
    }
  }

  removeSlot(detailIndex: number, slotIndex: number): void {
    const slots = this.variableDetailsArray.at(detailIndex).get('slots') as UntypedFormArray;
    if (slotIndex > 0) {
      slots.removeAt(slotIndex);
      this.slotCounts[detailIndex]--;
    }
  }

  getVendorName(id) {
    if (!!id) {
      let vendor = this.list.find(res => res.id === id);
      return !!vendor ? vendor.name : ''
    }
  }

  addDayToMap(index: number, day: string) {
    if (!this.daysMap.get(index)) {
      this.daysMap.set(index, [day])
      return;
    }
    this.daysMap.set(index, [...this.daysMap.get(index), day])
  }

  removeDayFromMap(index: number, day: string) {
    const dayArray = this.daysMap.get(index);
    if (dayArray) {
      const updatedArray = dayArray.filter(value => value !== day);
      this.daysMap.set(index, updatedArray);
    }
  }

  isDayUsed(day: string) {
    for (const [, value] of this.daysMap) {
      if (value.includes(day))
        return true;
    }
    return false;
  }

  selectUnselectedDays(index: number) {
    this.daysOfWeek.map((day) => {
      if (!this.isDayUsed(day)) {
        this.addDayToMap(index, day);
      }
    })
  }

  disableSelectedDay(index: number, day: string) {
    if (this.isDayUsed(day)) {
      if (!this.isDaySelected(index, day)) {
        return true;
      }
    }
    return false;
  }

  checkSlotOverlap(tariffDetailIndex: number, slotIndex: number) {
    const slotsArray = this.variableDetailsArray.at(tariffDetailIndex).get('slots') as UntypedFormArray;
    const currentSlot = slotsArray.at(slotIndex);
    const currentFrom = currentSlot.get('from').value;
    const currentTo = currentSlot.get('to').value;
    if (currentFrom && currentTo) {
      for (let i = 0; i < slotsArray.length; i++) {
        if (i !== slotIndex) {
          const otherSlot = slotsArray.at(i);
          const otherFrom = otherSlot.get('from').value;
          const otherTo = otherSlot.get('to').value;
          if (otherFrom && otherTo) {
            if (this.parseTime(currentFrom) < this.parseTime(otherTo) && this.parseTime(currentTo) > this.parseTime(otherFrom)) {
              this.toastr.error(this.translate.instant('tarrif.slotoverlapperror'));
              currentSlot.get('to').setValue('');
              return;
            }
          }
        }
      }
    }
  }

  areAllDaysSelected() {
    let count = 0;
    this.daysOfWeek.map((day) => {
      if (this.isDayUsed(day))
        count++;
    })
    if (count == 7)
      return true;
    return false;
  }

  getTimezone(usercountry: string) {
    switch (usercountry) {
      case countries.INDIA:
        this.timezone = 'Asia/Kolkata';
        break;
      case countries.NEPAL:
        this.timezone = 'Asia/Katmandu';
        break;
      default:
        this.timezone = 'UTC';
        break;
    }
  }

  checkCoverage(tariffDetailIndex: number): boolean {
    const slotsArray = this.variableDetailsArray.at(tariffDetailIndex).get('slots') as UntypedFormArray;
    let totalDuration = 0;
    for (let i = 0; i < slotsArray.length; i++) {
      const slot = slotsArray.at(i);
      const fromTime = this.parseTime(slot.get('from').value);
      const toTime = this.parseTime(slot.get('to').value);
      totalDuration += this.calculateTimeDifference(fromTime, toTime);
    }
    if (totalDuration !== 1439) {
      const tariffIndex = (tariffDetailIndex + 1);
      this.toastr.error(this.translate.instant('tarrif.timesloterror', { tariffIndex: tariffIndex }));
      return false;
    }
    return true;
  }

  calculateTimeDifference(fromTime: number, toTime: number): number {
    return toTime >= fromTime ? (toTime - fromTime) : (24 * 60 - fromTime + toTime);
  }

  convert12HrTo24Hr(timeStr: string): string {
    const timeParts = timeStr.split(' ');
    if (timeParts.length !== 2) {
      return timeStr;
    }
    const time = timeParts[0].split(':');
    const hours = parseInt(time[0]);
    const minutes = parseInt(time[1]);
    const period = timeParts[1].toUpperCase();
    if (period === 'AM') {
      if (hours === 12) {
        return `00:${time[1]}`;
      } else {
        return `${hours.toString().padStart(2, '0')}:${time[1]}`;
      }
    } else if (period === 'PM') {
      if (hours === 12) {
        return `12:${time[1]}`;
      } else {
        const convertedHours = (hours + 12).toString().padStart(2, '0');
        return `${convertedHours}:${time[1]}`;
      }
    } else {
      return timeStr;
    }
  }

  isAnyDetailWithoutRow() {
    for (const [key, value] of this.daysMap) {
      if (value.length == 0) { return true; }
    } return false;
  }

  ifTwelveSetElevenFiftyNine(tariffDetailIndex: number, slotIndex: number) {
    const slotsArray = this.variableDetailsArray.at(tariffDetailIndex).get('slots') as UntypedFormArray;
    const currentSlot = slotsArray.at(slotIndex);
    (currentSlot.get('to').value === '12:00 AM') && currentSlot.get('to').setValue('11:59 PM');
  }

  removeDaysForDeletedTariff(tariffDetailIndex: number) {
    this.daysMap.get(tariffDetailIndex).map(day => {
      this.removeDayFromMap(tariffDetailIndex, day);
      this.addDayToMap(tariffDetailIndex - 1, day);
    });
    this.selectUnselectedDays(tariffDetailIndex - 1);
    this.daysMap.delete(tariffDetailIndex);
  }

  onTypeChangeUpdate() {
    const length = this.variableDetailsArray.length;
    for (let i = 0; i < length; i++) {
      const slotsArray = this.variableDetailsArray.at(i).get('slots') as UntypedFormArray;
      for (let j = 1; j < slotsArray.length; j++) {
        slotsArray.at(j).get('type').setValue(slotsArray.at(0).get('type').value);
      }
    }
  }

  fromTimeGreaterThanToTime(tariffDetailIndex: number, slotIndex: number) {
    const slotsArray = this.variableDetailsArray.at(tariffDetailIndex).get('slots') as UntypedFormArray;
    const currentSlot = slotsArray.at(slotIndex);
    if (this.parseTime(currentSlot.get('from').value) >= this.parseTime(currentSlot.get('to').value)) {
      this.toastr.error(this.translate.instant('tarrif.toTimeError'));
      currentSlot.get('to').setValue('');
    }
  }

  selectedOperator(event) {
    this.operator = event
  }

  selectedCountry(event) {
    this.country = event
  }

  operatorAndCountryValidate(): boolean {
    if (!this.isEdit) {
      return (!!this.operator && !!this.country)
    } else {
      return true
    }
  }
}

